import React from 'react'

export const SvgListArrow = () => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 16h21m0 0l-7.27-8M27 16l-7.27 8" stroke="#919191" />
  </svg>
)

export const SvgListCheck = () => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M32.5 16.5c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16z"
      fill="#6EA668"
      stroke="#6EA668"
    />
    <path
      d="M9.323 17.062l.002-.002a.083.083 0 0 1 .067-.034.09.09 0 0 1 .055.02l5.441 4.427.41.334.31-.429 7.928-10.94v-.001a.088.088 0 0 1 .071-.037c.018 0 .034.004.052.018.02.015.035.038.04.071a.105.105 0 0 1-.02.079l-8.291 11.444h-.001a.089.089 0 0 1-.058.037h-.005H15.315a.09.09 0 0 1-.055-.02l-5.92-4.816h-.001a.111.111 0 0 1-.016-.151z"
      fill="#fff"
      stroke="#fff"
    />
  </svg>
)

export const SvgListUp = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="19.5" fill="#fff" stroke="#DDDCDC" />
    <path d="M27 19.608H12v.8h15v-.8z" fill="#5C5C5C" />
  </svg>
)

export const SvgListDown = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="19.5" fill="#fff" stroke="#DDDCDC" />
    <path
      d="M19.77 19.608H27v.8h-7.23V28h-.826v-7.593H12v-.8h6.944V12h.826v7.608z"
      fill="#5C5C5C"
    />
  </svg>
)

export const ArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="10" fill="none" viewBox="0 0 19 10">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M.151 9.858a.5.5 0 00.707-.01l8.392-8.63 8.392 8.63a.5.5 0 00.716-.697l-8.75-9a.5.5 0 00-.716 0l-8.75 9a.5.5 0 00.01.707z"
      clipRule="evenodd"
    />
  </svg>
)

export const ArrowDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="10" fill="none" viewBox="0 0 19 10">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M18.349.142a.5.5 0 00-.707.01L9.25 8.781.858.153a.5.5 0 00-.716.697l8.75 9a.5.5 0 00.716 0l8.75-9a.5.5 0 00-.01-.707z"
      clipRule="evenodd"
    />
  </svg>
)
